<div class="cookie-consent-banner" *ngIf="visible" role="dialog" aria-live="polite">
  <div class="cookie-consent-banner__message">
    <p class="mb-0">{{ 'label.cookie-consent-message' | transloco }}</p>
  </div>
  <div class="cookie-consent-banner__actions">
    <button type="button" class="btn btn-outline-secondary btn-extra-small" (click)="reject()">{{ 'label.cookie-consent-reject' | transloco }}</button>
    <button type="button" class="btn btn-primary btn-extra-small" (click)="accept()">{{ 'label.cookie-consent-accept' | transloco }}</button>
  </div>
</div>
